import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import { loadDevMessages, loadErrorMessages } from "@apollo/client/dev";
import { persistCache, LocalStorageWrapper } from 'apollo3-cache-persist';
import { type PropsWithChildren } from "react";

interface Props extends PropsWithChildren {}

const ENDPOINT = import.meta.env.PUBLIC_ENDPOINT ?? "https://stg-cms.avepoint.com/api";
const TOKEN = import.meta.env.PUBLIC_TOKEN ?? "T6t9Fa11ouec5Kkc75VeaIaPTX0yA7-h";

const cache = new InMemoryCache();

await persistCache({
  cache,
  storage: new LocalStorageWrapper(window.localStorage),
});

loadDevMessages();
loadErrorMessages();

const client = new ApolloClient({
  ssrMode: true,
  uri: ENDPOINT,
  headers: {
    authorization: TOKEN ? `Bearer ${TOKEN}` : "",
  },
  cache: cache,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'ignore',
      pollInterval: 10 * 1000,
    },
    query: {
      fetchPolicy: "cache-first",
      errorPolicy: 'ignore',
      pollInterval: 10 * 1000,
    }
  }
});

const Provider:React.FC<Props> = ({children}) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}

export default Provider;